import { WithdrawalRequestMap } from "./withdrawalRequestAction";

const initialState = {
  isLoading: false,
  transactionList: {},
  search: "",
  searchText: "",
  skip: 0,
  limit: 10,
  transaction_type: "",
  withdrawalRefreshTokenList: true,
  fromDate: "",
  toDate: "",
  pendingCount: 0,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case WithdrawalRequestMap.SET_PENDING_WITHDRAWAL_COUNT: {
      return {
        ...state,
        pendingCount: action.payload,
      };
    }
    case WithdrawalRequestMap.GET_WITHDRAWAL_REQUEST_REFRESH_TOKEN_TXN_LIST: {
      return {
        ...state,
        skip: 0,
        withdrawalRefreshTokenList: true,
      };
    }

    case WithdrawalRequestMap.GET_WITHDRAWAL_REQUEST_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case WithdrawalRequestMap.GET_WITHDRAWAL_REQUEST_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        transactionList: action.payload,
        withdrawalRefreshTokenList: false,
      };
    }
    case WithdrawalRequestMap.GET_WITHDRAWAL_REQUEST_ERROR: {
      return {
        ...state,
        isLoading: false,
        withdrawalRefreshTokenList: false,
      };
    }
    case WithdrawalRequestMap.GET_WITHDRAWAL_REQUEST_SEARCH_TEXT_CHANGE: {
      return {
        ...state,
        searchText: action.payload,
      };
    }

    case WithdrawalRequestMap.GET_WITHDRAWAL_REQUEST_SELECT_TEXT_CHANGE: {
      return {
        ...state,
        ...action.payload,
        withdrawalRefreshTokenList: true,
      };
    }
    case WithdrawalRequestMap.UPDATE_WITHDRAWAL_REQUEST_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case WithdrawalRequestMap.UPDATE_WITHDRAWAL_REQUEST_SUCCESS: {
      return {
        ...state,
        withdrawalRefreshTokenList: true,
      };
    }
    case WithdrawalRequestMap.UPDATE_WITHDRAWAL_REQUEST_ERROR: {
      return {
        ...state,
        isLoading: false,
        withdrawalRefreshTokenList: false,
      };
    }
    case WithdrawalRequestMap.SET_WITHDRAWAL_REQUEST_BATCH_NUMBER: {
      return {
        ...state,
        skip: action.payload,
        withdrawalRefreshTokenList: true,
      };
    }
    case WithdrawalRequestMap.SET_TO_DATE_CHANGES: {
      return {
        ...state,
        toDate: action.payload,
        withdrawalRefreshTokenList: true,
      };
    }
    case WithdrawalRequestMap.SET_FROM_DATE_CHANGES: {
      return {
        ...state,
        fromDate: action.payload,
        withdrawalRefreshTokenList: true,
      };
    }
    case WithdrawalRequestMap.RESET_FILTERS: {
      return {
        ...state,
        toDate: "",
        fromDate: "",
        transaction_type: "",
        search: "",
        searchText: "",
        withdrawalRefreshTokenList: true,
      };
    }

    default:
      return { ...state };
  }
};
